var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiFaceOffline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "70px",
    height: "80px",
    viewBox: "0 0 70 80",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1D1D1B",
    strokeWidth: 1.6382,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M48.825,20.037c-1.238-0.206-1.411,0.835-2.649,0.63c-1.241-0.206-1.068-1.247-2.309-1.453c-1.241-0.206-1.414,0.835-2.654,0.629"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1D1D1B",
    strokeWidth: 1.6382,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M49.727,12.313c-1.149,0.504-1.573-0.463-2.723,0.04c-1.15,0.504-0.728,1.471-1.878,1.974c-1.152,0.504-1.575-0.463-2.728,0.042 c-1.152,0.504-0.729,1.471-1.881,1.976"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1D1D1B",
    strokeWidth: 1.6382,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 34.08,
    y1: 39.261,
    x2: 34.08,
    y2: 20.087
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    stroke: "#1D1D1B",
    strokeWidth: 1.6382,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 34.079,
    cy: 19.343,
    r: 3.165
  }), /*#__PURE__*/React.createElement("image", {
    width: 22,
    height: 26,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAdCAYAAABfeMd1AAAACXBIWXMAAC4jAAAuIwF4pT92AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAMBJREFUeNpiYBgFJABGfJLK8grs QEoYyv119+GDN+RYwkSkBRQBJlpbgNUSaluAYQktLMAbJ1gAG9ARIhRZQitfkOoTullCVpANSp+Q 5ZtB6xOSfUOJT4i2aFAHF0m+oYZPCFpEreDCaxEzjPH+44e/QgICv4BMLjItYgbqZwea8w2nJSAA VMRCgSUwi3jRLUOxhAq+weorZnRZWljESIeGxC9mXDJU8hG4GcVIjEoSfYXRPmMk1Wk4LMTb8AMI MADLvUAP0UOqCQAAAABJRU5ErkJggg==",
    transform: "matrix(0.24 0 0 0.24 30.8257 16.4482)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M38.997,75.687c-3.176-1.434-6.814-1.434-9.99,0c0-1.861,0-3.724,0-5.585c3.176-1.434,6.814-1.434,9.99,0 C38.997,71.963,38.997,73.825,38.997,75.687z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M21.561,53.831c0,2.499-2.044,4.543-4.543,4.543h-3.2c-2.499,0-4.543-2.044-4.543-4.543v-6.552 c0-2.499,2.044-4.543,4.543-4.543h3.2c2.499,0,4.543,2.044,4.543,4.543V53.831z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1D1D1B",
    strokeWidth: 1.6382,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M21.561,53.831c0,2.499-2.044,4.543-4.543,4.543h-3.2c-2.499,0-4.543-2.044-4.543-4.543v-6.552c0-2.499,2.044-4.543,4.543-4.543 h3.2c2.499,0,4.543,2.044,4.543,4.543V53.831z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M58.792,53.831c0,2.499-2.044,4.543-4.543,4.543h-3.2c-2.499,0-4.543-2.044-4.543-4.543v-6.552 c0-2.499,2.044-4.543,4.543-4.543h3.2c2.499,0,4.543,2.044,4.543,4.543V53.831z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1D1D1B",
    strokeWidth: 1.6382,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M58.792,53.831c0,2.499-2.044,4.543-4.543,4.543h-3.2c-2.499,0-4.543-2.044-4.543-4.543v-6.552c0-2.499,2.044-4.543,4.543-4.543 h3.2c2.499,0,4.543,2.044,4.543,4.543V53.831z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M53.031,65.136c0,2.322-1.899,4.222-4.222,4.222H19.258c-2.322,0-4.222-1.899-4.222-4.222V35.585 c0-2.322,1.899-4.222,4.222-4.222h29.551c2.322,0,4.222,1.899,4.222,4.222V65.136z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1D1D1B",
    strokeWidth: 1.6382,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M53.031,65.136c0,2.322-1.899,4.222-4.222,4.222H19.258c-2.322,0-4.222-1.899-4.222-4.222V35.585c0-2.322,1.899-4.222,4.222-4.222 h29.551c2.322,0,4.222,1.899,4.222,4.222V65.136z"
  })), /*#__PURE__*/React.createElement("image", {
    width: 45,
    height: 159,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAACjCAYAAADIBU1XAAAACXBIWXMAAC4jAAAuIwF4pT92AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAlpJREFUeNrs3eFKwzAUhuHNVcGB MLwBBe//kgS9AhVholuZychkbl1tsiTnnPoWxpAx6dPzfWm7P51M2NiKbNPYLzzc3c/d27zjo+Xj 89NSCtIkAGbhdbh9Sk6kiUDcnACo2Jozp2ADEnb+ykLZLxJKbQdioRNDJzKzhOiEWItU30TMTeMI YnUaXRMxOY3e5RcIEB2QZXiZh7TuXqQlWkCAAAECBMhIIPNwL2MeIn4fQ7SAAAECBAgQIECAAAEC BAiQ8UNEf0nJCRH9JYVoAQECBAgQIEAUXm/lhohdbxEtIECAABkNROSkWAIiclIkWkCAALG1BJeC VF+CiRYQIHKQqitXSUjVlYtoAQEiC6m2cpWGVFu5iBYQw5Aqha8BqVJ4ogXEOKR44WtBiheeaAEZ AaRo4WtCihaeaP13SLGe1IYU6wnRAlKoJxKQIj0hWtriJQXJHi+iBaRQTyQhWXtCtLTFSxqSLV5E S1u8NECyxItoaYuXFsjZ8SJa2uKlCXJWvLRFK3kq2iDJU6Hs2uKlEZIUL63Rip6KVkj0VCi7tnhp hkTFS3u0Bk9FO2TwVCyUfdBULEAGTeUQIv6ImtSp/IKEx9O0Fqdi6YTYO5UuiNZ49U7l6IOXt9fN 7WKxCshLZZjG7dvG7eNqULQsdqWvI6ZWsJOQMJV3hZjOqfQuaYr7ctSVP8+Ye5jdk4w1gLYHdh8z 6ILMY9yrVQbymJXbry//xzTlP7iy+QPgHy58PZF9NOe2x/7h3U3Kt3fLswOt3ftHxh2LPTA/xZ9q Wo72Jh2zrf2B/RZgAMnQcl+1MEtiAAAAAElFTkSuQmCC",
    transform: "matrix(0.24 0 0 0.24 15.0366 31.5049)"
  }), /*#__PURE__*/React.createElement("image", {
    width: 27,
    height: 65,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAABDCAYAAABgFw6IAAAACXBIWXMAAC4jAAAuIwF4pT92AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAOxJREFUeNrs1sEKwjAMBuCuSncd 6n2Dvf8jDba7Rb0IetKDSrHRtRv5ZfLnOMq+pGlLCpMZbd3sUtd2Q7+XvhcTMJeR41WCVxmgS10f /n9TVeXhdDxnoQE4NSLYKoNGaokFgFHY1OzU0ZxrMeWqWeC2OhHV7KO4vSjwhSLBsFIYOPo4ECVK NEI1HveUSh17SpQoUaJEiS4G9XC0G/oLe0r0P1APR8P7w54SXSTq4Sj62vAgwVAPRx+HySNw+z48 BTi2p9pV228jo1bVo6dXo+p1zqDc1o0Eb1VQaUp/xodEZic2O+6JlebXcRNgAHvQUEtAsPxBAAAA AElFTkSuQmCC",
    transform: "matrix(0.24 0 0 0.24 9.208 42.8208)"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1D1D1B",
    strokeWidth: 1.3839,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 38.997,
    y1: 70.102,
    x2: 38.997,
    y2: 75.687
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1D1D1B",
    strokeWidth: 1.3839,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 29.006,
    y1: 75.687,
    x2: 29.006,
    y2: 70.102
  }), /*#__PURE__*/React.createElement("image", {
    width: 42,
    height: 28,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAAdCAYAAADVV140AAAACXBIWXMAAC4jAAAuIwF4pT92AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAKxJREFUeNrs2EEKgCAQBVA1Nwmd oaD7HymoMwS1UchAgsxCbaKCPyCC4PD+RhgZ+2nxnEtt3Si7KWLL1A39RAoPQAu3KMu4FRWER2Kf gKYEOYTgF+A3sNEheABdfQh8FmIU3mHxcfRmFH99DgEHHHDAAQcccMABBxxwwJNLEvRYp+/5xv2S ZfzRSAKktlO3yVXbAV17PaOCyETsLWSoXD+TGkS+gc0MsguwCDAAxmhCqCdG4/wAAAAASUVORK5C YII=",
    transform: "matrix(0.24 0 0 0.24 29.0063 69.0264)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1D1D1B",
    strokeWidth: 1.6382,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 23.993,
    y1: 45.167,
    x2: 27.406,
    y2: 48.58
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1D1D1B",
    strokeWidth: 1.6382,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 23.993,
    y1: 48.58,
    x2: 27.406,
    y2: 45.167
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1D1D1B",
    strokeWidth: 1.6382,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 40.663,
    y1: 45.167,
    x2: 44.076,
    y2: 48.58
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#1D1D1B",
    strokeWidth: 1.6382,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 40.663,
    y1: 48.58,
    x2: 44.076,
    y2: 45.167
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1D1D1B",
    strokeWidth: 1.6382,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M41.509,59.675c-1.392-2.719-4.21-4.584-7.475-4.584c-3.266,0-6.084,1.865-7.476,4.584"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiFaceOffline);
export default __webpack_public_path__ + "static/media/ai-face-offline.20e8d84eb4ae8d1ae1c7eab008b04441.svg";
export { ForwardRef as ReactComponent };